<template>
    <v-dialog v-model="showDialog" max-width="50%" persistent>
        <v-card>
            <v-card-title class="headline"><v-icon color="error accent-3" class="pr-5">sentiment_dissatisfied</v-icon>
                Sesión expirada</v-card-title>
            <v-card-text align="center" justify="center">
                <h3>Su sesión ha expirado. Para continuar, por favor inicie sesión nuevamente. </h3>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text @click="logout()">Iniciar sesión<v-icon>login</v-icon> </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data: () => ({

    }),
    name: "SessionExpired",
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        logout() {
           this.$store.dispatch("auth/logOut");
            this.$emit('closeDialog', true);
            // location.reload();
        }
    },
    components: {},
};
</script>
